export default __webpack_public_path__ + "static/media/bitcoin.com.8648d923.svg";